import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {AccountService} from "../services";
import {NotifierService} from "angular-notifier";


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private accountService: AccountService, private notifierService: NotifierService) {}

     isJsonString(str: any) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const skipIntercept = request.headers.has('skip_error');

        if (skipIntercept) {
          request = request.clone({
            headers: request.headers.delete('skip_error')
          });
        }

        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401 && this.accountService.userValue) {
                this.accountService.logout();
            }

            const error = err.error?.message || err.statusText;
            console.log("ErrorInterceptor", err);
            let error_list: Array<String> = [];
            console.log(typeof err.error)
            if (!skipIntercept){
              try{
                if (typeof err.error === 'object' && err.status > 0){
                  Object.entries(err.error).forEach(([key, value]) => {
                    if (typeof value === "string"){
                      error_list.push(value)
                    }else{
                      console.log("array", value);
                      error_list.push(...value as Array<any>)
                    }
                  });
                }else {
                  error_list.push('Ha ocurrido un error desconocido, vuelve a intentarlo')
                  this.notifierService.notify('error', `Ha ocurrido un error desconocido, vuelve a intentarlo`)
                }
              }catch (e){
                console.log("intercet catch", e);
              }
            }

            err.error_list = error_list

            return throwError(err);
        }))
    }
}
